import React, { useState } from "react";
import { plus, rockets } from "./../../Public/assets/index";
import { Button } from "./../../Components/ui/button.jsx";
import { CurrencyGrid } from "./../../Components/CurrencyCard";
import { useOverview } from "./../../hooks";
import { Eye, EyeOff } from "lucide-react";

const AccountDashboard = ({
  setIsOpen,
  noPayment,
  data,
  partnerHealthDisable,
}) => {
  const firstName = data?.user?.name?.split(" ");

  const [showFull, setShowFull] = useState(false);

  const displayNumber = showFull
    ? data?.vendorAccountNo
    : `*******${data?.vendorAccountNo?.slice(-4) || ""}`;

  const { useWalletDetails, setCurrentFlow } = useOverview();
  const { data: walletData, isLoading: walletDataIsLoading } =
    useWalletDetails();

  return (
    <>
      <div
        className={`bg-white  pt-3.5 ${
          noPayment ? "pb-3.5" : ""
        }  lg:rounded-xl lg:shadow-custom lg:border lg:!mx-40`}
      >
        <div className="flex justify-between items-center flex-wrap px-6  mb-4  pb-4 md:pb-0  border-b  sm:border-none ">
          <div className=" flex flex-col gap-[2px]">
            <h1 className="text-xl !font-geomanistBold md:text-[22px] font-normal leading-[44px] text-blackShade">
              Hello {firstName?.[0]},
            </h1>
            <p className="text-greyish  leading-[28px] font-normal ">
              Welcome to your account
            </p>
            <p className="">
              <div className="flex items-center gap-2">
                <span className="text-greyish  leading-[28px]  font-normal">
                  {displayNumber}
                </span>
                <button
                  onClick={() => setShowFull(!showFull)}
                  className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                  aria-label={
                    showFull
                      ? "Hide account number"
                      : "Show full account number"
                  }
                >
                  {showFull ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </p>
          </div>

         <div
            className={` ${
              noPayment ? "hidden" : "flex"
            }  flex-wrap gap-2  md:gap-4 mt-4 md:mt-0  w-full md:w-auto `}
          >
            <div className="w-[48%] md:!w-auto">
              <Button
                variant="default"
                size="default"
                disabled={partnerHealthDisable}
                className="w-full md:w-auto rounded-[8px]"
                onClick={() => {
                  setIsOpen(true);
                  setCurrentFlow("AddFunds");
                }}
              >
                <img src={plus} alt="plus" className="mr-2 h-4 w-4 " /> Add
                Money
              </Button>
            </div>
            <div className="w-[48%] md:!w-auto">
              <Button
                variant="outline"
                size="default"
                disabled={partnerHealthDisable}
                className="w-full md:w-auto border-blueish rounded-[8px]"
                onClick={() => {
                  setIsOpen(true);
                }}
              >
                <img src={rockets} alt={"rockets"} className="mr-2 h-4 w-4 " />{" "}
                Send Money
              </Button>
            </div>
          </div>
        </div>

        <CurrencyGrid
          walletDataIsLoading={walletDataIsLoading}
          accounts={walletData?.data?.accounts}
          noPayment={noPayment}
          disabled={partnerHealthDisable}
        />
      </div>
    </>
  );
};

export default AccountDashboard;
